import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 数字资产类目列表
export const setDigitalDefs: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 已发布的类目列表
export const setPublishedDefs: Mutation<IModuleState> = (state, payload) => {
  state.publishedDefs.data = payload.data;
  state.publishedDefs.loading = !!payload.loading;
};

// 数字资产类目详情
export const setDigitalDefDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 数字资产类目缩略图
export const setDigitalDefThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = !!payload.loading;
};

// 数字资产类目修改日志列表
export const setDigitalDefLogs: Mutation<IModuleState> = (state, payload) => {
  state.logs.data = payload.data;
  state.logs.pageNum = payload.pageNum;
  state.logs.pageSize = payload.pageSize;
  state.logs.total = payload.total;
  state.logs.loading = !!payload.loading;
};

// 已发布的系统数字资产属性列表
export const setDigitalPublishedAttrs: Mutation<IModuleState> = (state, payload) => {
  state.publishedAttrs.data = payload.data;
  state.publishedAttrs.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
